import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import dvo from "../../Assets/Projects/dvo.png";
import vacpy from "../../Assets/Projects/vacpic.png";
import paper from "../../Assets/Projects/paper.png";
import adco from "../../Assets/Projects/adco.png";
import husky from "../../Assets/Projects/husky.png";
import bitsOfCode from "../../Assets/Projects/rvac.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects & research I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={adco}
              isBlog={false}
              title="¡Adiós COVID!"
              description="An all-volunteer project led by Dr. Leo Morales and Frank Martinez, ¡Adiós COVID! aims to facilitate vaccination and wellness for Latinos in Washington state. We partner with grassroots community-based organizations to conduct outreach and provide wellness resources for Latino communities. The project is a multidisciplinary collaboration involving the Center for Latino Health, University of Washington Information School, and dedicated individuals from the Seattle area."
              ghLink="https://github.com/Adios-COVID"
              demoLink="https://research.adioscovid.org/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={paper}
              isBlog={false}
              title="Logistic Regression Model in U.S. College Admission Result Forecast"
              description="This project utilizes logistic regression, a classification algorithm with a linear discriminant, to predict admission decisions for Chinese applicants to U.S. graduate schools. By estimating probabilities through a logit/sigmoid function, the model assesses the relationship between the categorical dependent variable and one or more independent variables."
              ghLink="https://github.com/IrisDin/Logistic-Regression-Model-in-U.S.-College-Admission-Result-Forecast"
              demoLink="https://nbviewer.org/github/IrisDin/Logistic-Regression-Model-in-U.S.-College-Admission-Result-Forecast/blob/master/Admission%20Program.ipynb"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Global Covid-19 Vaccination Analysis Web Application"
              description="In response to the COVID-19 pandemic, this interactive web application offers visualizations of worldwide vaccination data. The application emphasizes the urgency of vaccination and the need for universal accessibility to promote public health and safety.              "
              ghLink="https://github.com/IrisDin/vaccination_visulization_inR"
              demoLink="https://irisdin.shinyapps.io/final-project-IrisDin/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={vacpy}
              isBlog={false}
              title="COVID-19 Vaccination, Cases, and Deaths Worldwide Data Analysis and visualization in Python"
              description="This project analyzes global COVID-19 vaccination, cases, and deaths using Python. Detailed insights can be found in the project report, method.py, project_notebook.ipynb, and interactive visualizations available in the attached Tableau workbook.              "
              ghLink="https://github.com/IrisDin/Covid_19_analysis"
              demoLink="https://nbviewer.org/github/IrisDin/Covid_19_analysis/blob/main/project_notebook.ipynb"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={dvo}
              isBlog={false}
              title="Dvogue"
              description="Dvogue is a clothing recommendation website that matches, searches, saves, and recommends outfits based on user input and preferences.
              "
              ghLink="https://github.com/info340a-sp22/project-IrisDin"
              demoLink="https://dvogue-a1779.web.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={husky}
              isBlog={false}
              title="Husky connect"
              description="Husky Connect is an app prototype designed to help University of Washington students find and connect with like-minded groups, fostering a sense of community and belonging on campus.              "
              ghLink="https://github.com/IrisDin/husky_connect"
              demoLink="https://www.figma.com/proto/SpChOcwKDo1uVFBVMXj3bx/info360?node-id=304%3A358&scaling=scale-down&page-id=0%3A1&starting-point-node-id=304%3A358"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
